import React from "react";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";

const DarkThemeProvider = ({ children }) => {
    const isDarkMode = useSelector((state) => state.isDark);

    return (
        <ThemeProvider theme={{ theme: isDarkMode ? "dark" : "light" }}>
            {children}
        </ThemeProvider>
    );

};

export default DarkThemeProvider;
